export default "__VITE_ASSET__DElQyci3__"